/**
 * Utility functions for the portfolio site
 */

/**
 * Format a date string from M/D/YY format to a readable format
 * @param dateStr - Date string in M/D/YY format (e.g., "9/1/14")
 * @returns Formatted date string (e.g., "September 1, 2014") or original string if parsing fails
 */
export function formatDate(dateStr: string): string {
  if (!dateStr) return "";

  // Parse date in M/D/YY format
  const parts = dateStr.split("/");
  if (parts.length === 3) {
    const month = parseInt(parts[0], 10);
    const day = parseInt(parts[1], 10);
    const shortYear = parseInt(parts[2], 10);
    const year = shortYear + (shortYear > 50 ? 1900 : 2000);

    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }

  return dateStr;
}

/**
 * Truncate text to a specified length with ellipsis
 * @param text - Text to truncate
 * @param maxLength - Maximum length before truncation
 * @returns Truncated text with ellipsis if needed
 */
export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength).trim()}...`;
}

/**
 * Generate a slug from a title string
 * @param title - Title string to convert
 * @returns URL-friendly slug
 */
export function slugify(title: string): string {
  return title
    .toLowerCase()
    .replace(/[^\w\s-]/g, "") // Remove special characters
    .replace(/[\s_-]+/g, "-") // Replace spaces and underscores with hyphens
    .replace(/^-+|-+$/g, ""); // Remove leading/trailing hyphens
}
